import React from "react";

import * as Table from "~/Table";

import * as Body from "./Body";
import * as Head from "./Head";

export { colSpan } from "./Head";

export const Component: React.Fn = () => (
  <Table.Scroll.Component>
    <Table.Component>
      <Head.Component />
      <Body.Component />
    </Table.Component>
  </Table.Scroll.Component>
);
